import { createBrowserRouter } from 'react-router-dom';

import { navigation } from '@app/data';
import { RootProviders } from '@app/routes';

import { ErrorPage } from '@pages/ErrorPage';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <RootProviders />,
      errorElement: <ErrorPage />,
      children: navigation,
    },
  ],
  { future: { v7_relativeSplatPath: true } }
);
